module.exports = __webpack_public_path__ + "static/media/yce-button-web.4eeae30e.svg";